<div class="page-sub-title">Create Drill</div>

<div class="padded-container margin-top-large">
  <p>
    <label for="drillLabel">Drill Name</label>
    <input
      id="drillLabel"
      type="text"
      class="input full-width"
      placeholder="Ex: Driver stock swing"
      [(ngModel)]="drill.label"
      name="drillLabel"
      autocapitalize="words"
    />
  </p>

  <p>
    <label for="drillDescription">Description</label>
    <textarea
      id="drillDescription"
      class="input full-width"
      rows="4"
      placeholder="Optional notes about the drill"
      [(ngModel)]="drill.description"
      name="drillDescription"
    ></textarea>
  </p>

  <p>
    <label for="clubId">Club</label>
    <select
      id="clubId"
      class="input full-width"
      [(ngModel)]="drill.club_id"
      (ngModelChange)="onClubChange($event)"
      name="clubId"
    >
      <option [ngValue]="null">Select a club</option>
      <option *ngFor="let club of clubs" [ngValue]="club.id">
        {{ club.label }}
      </option>
    </select>
  </p>

  <p>
    <label for="assessmentAreaCode">Result type</label>
    <select
      id="assessmentAreaCode"
      class="input full-width"
      [(ngModel)]="drill.assessment_area"
      name="assessmentAreaCode"
    >
      <option [ngValue]="null">Select a result type</option>
      <option *ngFor="let aa of assessmentAreas" [ngValue]="aa.code">
        {{ aa.label }}
      </option>
    </select>
  </p>

  <p>
    <button class="btn btn-green btn-full-width margin-top-large" (click)="saveDrillClicked()">
      Save Drill
    </button>
  </p>
</div>
